export function Logo({ className = 'size-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#0b2a45" />
      <circle cx="21" cy="12" r="5" fill="#f08a4b" />
      <rect x="7" y="19" width="18" height="3" rx="1.5" fill="#5fd4c8" />
    </svg>
  );
}
